import script from "./welfareView.vue?vue&type=script&setup=true&lang=ts"
export * from "./welfareView.vue?vue&type=script&setup=true&lang=ts"

import "./welfareView.vue?vue&type=style&index=0&id=2cc3266b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cc3266b"]])

export default __exports__